export function MyCourseCardSkeleton() {
  return (
    <div className="rounded-xl bg-background w-full flex flex-col border border-default-100 p-3 gap-4 items-center animate-pulse">
      <div className="flex flex-row w-full gap-2 items-center">
        <div className="aspect-square size-16 rounded-lg bg-content4"></div>

        <div className="flex flex-col gap-2 flex-1">
          <div className="h-3 bg-content4 rounded w-3/4"></div>
          <div className="h-2 bg-content4 rounded w-1/2"></div>
        </div>

        <div className="size-10 rounded-lg bg-content4"></div>
      </div>

      <div className="w-full h-px bg-default-100"></div>

      <div className="flex flex-row w-full items-center justify-between gap-2">
        <div className="flex-1"></div>
        <div className="flex items-center gap-1">
          <div className="h-3 bg-content4 rounded w-16"></div>
          <div className="size-4 bg-content4 rounded"></div>
        </div>
      </div>
    </div>
  );
}
